module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Db-Fb-Ga-Hc-Ia.fe18f5fc.png";